import React from "react";
import { Button, Result } from "antd";
// import { useNavigate } from "react-router-dom";

const ErrorPage = () => {
  // const navigate = useNavigate();

  const handleBackHome = () => {
    window.history.back();
  };

  return (
    <Result
      status="404"
      //   title="500"
      subTitle="Sorry, something went wrong."
      extra={
        <Button type="primary" onClick={handleBackHome}>
          Go Back
        </Button>
      }
    />
  );
};

export default ErrorPage;
